import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getSpecialities = () =>
  ConfigCmsApi.get("/doctors/specialities", { headers: headers() });

const upsertSpeciality = (data) =>
  ConfigCmsApi.post("/doctors/specialities", data, { headers: headers() });

const getAccreditations = () =>
  ConfigCmsApi.get("/clinics/accreditations", { headers: headers() });

const upsertAccreditation = ({ data, logoFile }) => {
  // If logo file present — use multipart; else JSON
  if (logoFile) {
    const formData = new FormData();
    formData.append("id", String(data.id || 0));
    formData.append("name", JSON.stringify(data.name || {}));
    formData.append("description", JSON.stringify(data.description || {}));
    formData.append("abbreviation", data.abbreviation || "");
    formData.append("web_site_link", data.web_site_link || "");
    formData.append("country_code", data.country_code || "");
    formData.append("logo", logoFile);
    return ConfigCmsApi.post("/clinics/accreditations", formData, {
      headers: { ...headers(), "Content-Type": "multipart/form-data" },
    });
  }
  return ConfigCmsApi.post("/clinics/accreditations", data, { headers: headers() });
};

export default {
  getSpecialities,
  upsertSpeciality,
  getAccreditations,
  upsertAccreditation,
};
